export enum TaskType {
  Basic = "Basic",
  JoinSigning = "JoinSigning"
}
